import log from 'salvo-lite/log'
import axios from 'axios'

class Variants {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._variants = elem.querySelectorAll('[data-variant]')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._variants.forEach(variant => {
            variant.addEventListener('click', e => {
                const id = variant.getAttribute('data-variant')
                this._updateContent(id)
                this._updateUrl(id)
                this._updateImage(variant.getAttribute('data-variant-image'))
            })
        })
    }
    _updateContent (id) {
        axios.get(window.location.pathname + '?variant=' + id).then((response) => {
            const productPageContent = document.createElement('div')
            productPageContent.innerHTML = response.data
            const newVariantList = productPageContent.querySelector('.product__variants').innerHTML
            const newPrice = productPageContent.querySelector('.product__cta').innerHTML
            const newMax = productPageContent.querySelector('.product__actions [name="quantity"]').getAttribute('max')
            this._updatePrice(newPrice)
            this._updateVariantList(newVariantList)
            this._quantity(newMax)
        }).then((response) => {
            this._theme.registerComponents(document.querySelector('.product__form'))
            window.esc_now_back_in_stock.triggerRefresh()
        })
    }
    _updateUrl (id) {
        let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + id
        window.history.replaceState({ path: newurl }, '', newurl)
    }
    _updatePrice (price) {
        document.querySelector('.product__cta').innerHTML = price
    }
    _updateVariantList (content) {
        this._elem.innerHTML = content
    }
    _quantity (max) {
        document.querySelector('.product__actions [name="quantity"]').setAttribute('max', max)
        if (document.querySelector('.product__actions [name="quantity"]').value > max) {
            document.querySelector('.product__actions [name="quantity"]').value = max
        }
    }
    _updateImage (image) {
        if (image) {
            document.querySelector('.product__image.large img').setAttribute('src', image)
        }
    }
}

export default Variants



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Variants.js